import { AbstractControl, ValidationErrors } from "@angular/forms";

export class CustomValidators {
    static user(control: AbstractControl): ValidationErrors | null {
        const user: string = control.value;

        if (user !== "abbvie") {
            return {
                user: "Incorrect user."
            };
        }

        return null;
    }

    static password(control: AbstractControl): ValidationErrors | null {
        const password: string = control.value;

        if (password !== "screenforepiincp") {
            return {
                password: "screenforepiincp"
            };
        }

        return null;
    }
}
